// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { auroraTestnet as _auroraTestnet } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the auroraTestnet chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 1313161555
 * Chain Name: Aurora Testnet
 * Default Block Explorer: https://testnet.aurorascan.dev
 * Default RPC URL: https://testnet.aurora.dev
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { auroraTestnet } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: auroraTestnet,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const auroraTestnet = createCommon({
	..._auroraTestnet,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
